// import './modules/polyfills.js';

import { nav_toggler } from './modules/common.js';
import cookie_consent from './modules/cookie_consent.js';
import collapsibles from './modules/collapsibles.js';
//import tippy from 'tippy.js';
import tippy from "tippy.js/dist/tippy.umd.js";

// doc ready
const dom_is_ready = ( callback ) => {

    if ( document.readyState !== 'loading' ) {

        callback();

    } else {

        document.addEventListener( 'DOMContentLoaded', callback );

    }

};

dom_is_ready( () => {

    // toggle nav
    nav_toggler();

    // uitklap componenten (zoals onze nav)
    collapsibles();

    // cookie consent
    cookie_consent();

    // tippy tooltips
    tippy( '[data-tippy-content]', {
        allowHTML: true
    } );

    // forms
    if ( document.querySelectorAll( '.portal-form' ).length ) {

        import( './modules/forms.js' ).then( ( {
               default: forms
           } ) => {

          forms();

        } );

    }

    // filter forms
    if ( document.querySelectorAll( '.filter-form' ).length ) {

        import( './modules/filter_forms.js' ).then( ( {
               default: filter_forms
           } ) => {

            filter_forms();

        } );

    }

	// pdf files openen in pdf.js
	if ( document.querySelectorAll( 'a.open-viewer[data-pdf-file]' ).length ) {

		import( './modules/viewer.js' ).then( ( {
              default: init_viewer
            } ) => {

			init_viewer();

		} );

	}

	// magazine jaar filtering via js
	if ( document.querySelector( '#m-year' ) ) {

		import( './modules/magazine_overview.js' ).then( ( {
                default: magazine_overview
            } ) => {

			magazine_overview();

		} );

	}

    // alpine enabled pages
    if ( document.getElementById( 'alpine-enabled' ) ) {

        import( './modules/alpine_enabled.js' ).then( ( {
               default: init_alpine
           } ) => {

            init_alpine();

        } );

    }

    // payment pending page
    if ( document.querySelector( '.content-payment-pending' ) ) {

        import( './modules/payment_pending.js' ).then( ( {
               default: payment_pending
           } ) => {

            payment_pending();

        } );

    }

} );
